const headers = () => ({
  Accept: 'application/json'
});

export const getJson = href =>
  fetch(href, {
    method: 'GET',
    headers: headers(),
    credentials: 'same-origin'
  })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(`Unexpected response: ${response.status} - ${response.statusText}`);
      }
      return response.json();
    });

export const postJson = (href, bodyJson) =>
  fetch(href, {
    method: 'POST',
    headers: headers(),
    credentials: 'same-origin',
    body: JSON.stringify(bodyJson)
  })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(`Unexpected response: ${response.status} - ${response.statusText}`);
      }
      return response.json();
    });

export const putJson = (href, bodyJson) =>
  fetch(href, {
    method: 'PUT',
    headers: headers(),
    credentials: 'same-origin',
    body: JSON.stringify(bodyJson)
  })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(`Unexpected response: ${response.status} - ${response.statusText}`);
      }
      return response.json();
    });

export const deleteJson = href =>
  fetch(href, {
    method: 'DELETE',
    headers: headers(),
    credentials: 'same-origin'
  })
    .then(response => response.json());
